import React from 'react';
import { NavLink } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Header.css'

function Header() {
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary fixed-top">
        <Container>
          <Navbar.Brand>
            <div className="logo">
              <NavLink to="/">
                <img className="c1 ms-2" style={{ width: '70px', marginLeft: '-40px' }} src="img/icon/Mukundiconog.png" alt="logo" />
              </NavLink>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto mt-2">
              <NavLink className="nav-link me-4" to="/" activeClassName="active-nav">Home</NavLink>
              <NavLink className="nav-link me-4" to="/products" activeClassName="active-nav ">Products</NavLink>
              <NavLink className="nav-link me-4" to="/contact" activeClassName="active-nav">Contact</NavLink>
              <NavLink className="nav-link me-4" to="/aboutus" activeClassName="active-nav">About Us</NavLink>
            </Nav>

            <Nav className="contact-info12">
              <div className="header-cta">
                <ul className="mt-2" style={{ display: 'flex', alignItems: 'center' }}>
                  <li style={{ display: 'flex', alignItems: 'center' }}>
                    <i style={{ color: 'rgb(210, 33, 39)' }} className="icon fal fa-envelope"></i>
                    <a href="mailto:info@mukundmachine.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                      <span style={{ color: '#0d0d0e' }}>info@mukundmachine.com</span>
                    </a>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center' }}>
                    <i style={{ color: 'rgb(210, 33, 39)' }} className="icon fal fa-phone"></i>
                    <span style={{ fontWeight: '400', color: 'black' }}>00914972700966</span>
                  </li>
                </ul>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
